import React, { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import icon from "../assets/user-group.png";
import arrow from "../assets/arrow-up-right-svgrepo-com (1).svg";
import iconBottomup from "../assets/statistic-up.svg";
import iconBottomdown from "../assets/statistic-down.svg";
import {
  LineChart,
  Line,
  XAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  ReferenceLine,
  BarChart,
  Bar,
  YAxis,
  PieChart,
  Pie,
  Cell,
  Legend,
} from "recharts";

// بيانات الإحصائيات
const stats = [
  {
    title: "Total Revenue",
    value: "$81.000",
    change: "+10.6%",
    color: "text-green-500",
    gradient: false,
    bg: "agarly-gradient-bg",
    bottomIcon: iconBottomup,
  },
  {
    title: "Total Customer",
    value: "5.000",
    change: "+1.5%",
    color: "text-green-500",
    gradient: true,
    bg: "bg-white",
    bottomIcon: iconBottomup,
  },
  {
    title: "Total Transactions",
    value: "12.000",
    change: "+3.6%",
    color: "text-green-500",
    gradient: true,
    bg: "bg-white",
    bottomIcon: iconBottomup,
  },
  {
    title: "Total Product",
    value: "5.000",
    change: "-1.5%",
    color: "text-red-500",
    gradient: true,
    bg: "bg-white",
    bottomIcon: iconBottomdown,
  },
];

const ViewVendor = () => {
  const location = useLocation();
  const vendor = location.state?.Vendor || { name: "" };
  const initialTab = location.state?.activeTab || "";

  const [activeTab] = useState(initialTab);

  const data = [
    { month: "Jan", avgValue: 12000, avgItem: 15000 },
    { month: "Feb", avgValue: 18000, avgItem: 17000 },
    { month: "Mar", avgValue: 16000, avgItem: 19000 },
    { month: "Apr", avgValue: 20000, avgItem: 22000 },
    { month: "May", avgValue: 25000, avgItem: 23000 },
    { month: "Jun", avgValue: 27000, avgItem: 26000 },
    { month: "Jul", avgValue: 30000, avgItem: 31000 },
    { month: "Aug", avgValue: 28000, avgItem: 29000 },
    { month: "Sep", avgValue: 24000, avgItem: 25000 },
    { month: "Oct", avgValue: 22000, avgItem: 24000 },
    { month: "Nov", avgValue: 21000, avgItem: 23000 },
    { month: "Dec", avgValue: 26000, avgItem: 27000 },
  ];

  const barData = [
    { name: "Linux", sales: 15000 },
    { name: "Mac", sales: 28000 },
    { name: "iOS", sales: 12000 },
    { name: "Windows", sales: 25000 },
    { name: "Android", sales: 8000 },
    { name: "Other", sales: 22000 },
  ];
  const barColors = ["#9F9FF8", "#96E2D6", "#000000", "#92BFFF", "#AEC7ED", "#94E9B8"];

  const pieData = [
    { name: "United States", value: 52.2 },
    { name: "Canada", value: 22.8 },
    { name: "Mexico", value: 13.9 },
    { name: "Other", value: 11.2 },
  ];
  const pieColors = ["#000000", "#92BFFF", "#94E9B8", "#AEC7ED"];

  return (
    <div>
      <div className="md:p-10 pb-4 p-4 text-base gap-4 w-full">
        {/* Page Titles */}
        <h1 className="text-2xl font-bold mb-2 dark:text-gray-200">Vendor Details</h1>
        <p className="text-gray-600 pb-6 text-sm flex flex-wrap gap-1 items-center dark:text-gray-400">
          <Link to="/dashboard" className="hover:underline">Dashboard</Link>{" / "}
          <Link to={`/Users?selected=${activeTab}`} className="hover:underline">Vendors</Link>{" / "}
          <span className="agarly-gradient-text font-bold">
            {vendor.name || "No name available"}

          </span>
        </p>

        {/* Vendor Info */}
        <div className="flex justify-center flex-col rounded-2xl md:p-0 gap-6 ">
          <div className="flex justify-center ">
            <div className="flex items-center gap-2 bg-white px-20 md:px-40 py-2 rounded-2xl shadow-md dark:bg-[#1A1A1B]">
              <img src={icon} alt="" className="w-5 h-5" />
              <p className="text-sm font-medium text-gray-500 dark:text-gray-400">
                {vendor.name || "No name available"}
              </p>
            </div>
          </div>

          {/* Charts Container */}
          <div className="flex flex-wrap gap-4 w-full">
            <div className="flex flex-1 flex-wrap gap-6">
              {/* Stats Cards */}
              <div className="grid grid-cols-2 gap-4 w-[50%] min-w-[375px]">
                {stats.map((item, index) => (
                  <div
                    key={index}
                    className={`p-4 rounded-[24px] shadow-sm ${item.bg} flex flex-col min-w-[140px] h-[160px] w-full flex-1 hover:-translate-y-1 hover:shadow-lg transition
                      dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]`}
                  >
                    {/* First section */}
                    <div className="flex items-center justify-between mb-2">
                      <h4 className="text-base font-medium text-gray-600 dark:text-gray-200">{item.title}</h4>
                      <img src={arrow} alt="" className="w-5 h-5" />
                    </div>

                    {/* Second section */}
                    <div className="flex-1 flex flex-wrap items-end justify-between">
                      <div
                        className={`text-3xl font-extrabold ${
                          item.gradient
                            ? "agarly-gradient-text"
                            : "text-white"
                        }`}
                      >
                        {item.value}
                      </div>

                      <div className="flex lg:flex-col items-end text-sm">
                        <div className={`flex items-center ${item.color}`}>
                          <img src={item.bottomIcon} alt="" className="w-4 h-4" />
                          <span className={`${item.color} text-xs`}>{item.change}</span>
                        </div>
                        <span className="text-[12px] text-gray-400"> &nbsp; From last week</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Sales Line Chart */}
              <div className="bg-white p-4 rounded-[24px] shadow-md flex-1 min-w-[350px] md:w-[48%] dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
                <div className="flex justify-between items-start mb-2 ">
                  <div>
                    <h2 className="text-[16px] font-semibold text-gray-800 dark:text-gray-200">Your Sales this year</h2>
                    <div className="flex flex-wrap items-center gap-4 text-[14px] dark:text-gray-400 text-gray-500 mt-1">
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-[#6AA885]"></span> Average Sale Value
                      </div>
                      <div className="flex items-center gap-1">
                        <span className="w-3 h-3 rounded-full bg-[#1a71f6]"></span> Average item per sale
                      </div>
                    </div>
                  </div>
                  <button className="flex text-[14px] w-[100px] text-gray-600 hover:underline  dark:text-gray-200">
                    Show All <img src={arrow} alt="" className="w-5 h-5" />
                  </button>
                </div>

                <div className="flex gap-4 mb-4 justify-center items-center">
                  <div className="border-2 max-w-[140px] border-dashed border-[#1a71f6] px-1 py-1 rounded-xl text-center flex-1">
                    <div className="text-[10px] text-gray-500  dark:text-gray-400">Average item per sale</div>
                    <div className="font-bold text-[14px] text-[#454545]  dark:text-gray-200">$211,411,223</div>
                  </div>
                  <div className="bg-[#6AA885] max-w-[130px] text-white px-1 py-1 rounded-xl text-center flex-1">
                    <div className="text-[10px] text-gray-500  dark:text-gray-700">Average year on year</div>
                    <div className="font-bold text-[14px] text-[#454545]  dark:text-gray-900">$339,091,888</div>
                  </div>
                </div>

                <ResponsiveContainer width="100%" height={190}>
                  <LineChart data={data}>
                    <CartesianGrid stroke="#eee" strokeDasharray="3 3" className="dark:stroke-gray-700"/>
                    <XAxis dataKey="month" interval={0} tick={{ fontSize: 11 }} padding={{ left: 20, right: 20 }} />
                    <Tooltip/>
                    <ReferenceLine x="Jul" stroke="rgba(62, 113, 214, 0.8)" strokeWidth={2} />
                    <Line type="monotone" dataKey="avgItem" stroke="#5DEBFF" strokeWidth={3} strokeDasharray="7 7" dot={false} />
                    <Line type="monotone" dataKey="avgValue" stroke="#6AA885" strokeWidth={3} dot={false} />
                  </LineChart>
                </ResponsiveContainer>
              </div>

              {/* Bar Chart */}
              <div className="bg-white rounded-xl shadow p-4 flex-1 min-w-[350px] md:w-[48%] dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
                <h2 className="text-lg font-bold mb-4 dark:text-gray-200">Most Product Sell</h2>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={barData} margin={{ top: 20, right: 20, left: 0, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} />
                    <XAxis dataKey="name" axisLine={false} tickLine={false} />
                    <YAxis tickFormatter={(value) => `${value / 1000}K`} axisLine={false} tickLine={false} />
                    <Tooltip cursor={false} />
                    <Bar dataKey="sales" radius={[8, 8, 8, 8]} barSize={30}>
                      {barData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={barColors[index % barColors.length]} />
                      ))}
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </div>

              {/* Doughnut Chart */}
              <div className="bg-white rounded-xl shadow p-4 flex-1 min-w-[350px] md:w-[48%] dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
                <h2 className="text-lg font-bold mb-4 dark:text-gray-200">Traffic by Location</h2>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <defs>
                      <linearGradient id="blackGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#000000" />
                        <stop offset="50%" stopColor="#333333" />
                        <stop offset="100%" stopColor="#777777" />
                      </linearGradient>
                    </defs>
                    <Pie data={pieData} cx="50%" cy="50%" innerRadius={50} outerRadius={100} paddingAngle={3} dataKey="value" cornerRadius={10}>
                      {pieData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={index === 0 ? "url(#blackGradient)" : pieColors[index % pieColors.length]}
                          stroke="#fff"
                          strokeWidth={2}
                        />
                      ))}
                    </Pie>
                    <Tooltip formatter={(value) => `${value}%`} />
                    <Legend layout="vertical" verticalAlign="middle" align="right" iconType="circle" iconSize={12} wrapperStyle={{ lineHeight: "34px" }} />
                  </PieChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "40px" }}></div>
    </div>
  );
};

export default ViewVendor;
